<template>
       <v-container fluid class="primary">
        <v-container>
            <v-row class="">
                <v-col>
                    <h1 class="fifth--text display-2 mb-4">Work Experience</h1>
                </v-col>
            </v-row>    
            <v-row class="d-flex justify-space-between">
                <v-col v-for="work in workPos" :key="work.title" class="d-flex align-stretch" md="6" cols="12">
                    <v-card class="fifth"  raised>
                        <v-row style="height:100%;">
                            <v-col cols="2" class="pt-0 pb-0 pr-0">
                        <v-img
                        style="border-radius: 2px;"
                        :src="work.img"
                        min-height="100%"
                        
                        />                        
                            </v-col>
                            <v-col>
                        <v-card-title class="primary--text headline font-weight-bold">{{ work.title }}</v-card-title>
                        <v-card-subtitle class="primary--text title font-weight-regular">{{ work.subtitle }}</v-card-subtitle>
                        <v-card-text class="primary--text subtitle-1 font-weight-regular">{{ work.text }}</v-card-text>
                        <a class="blue--text subtitle-1 pl-4" target="_blank" v-for="site in work.sites" :key="site.title" :href="site.href">- {{site.title}} <br></a>
                            </v-col>
                        </v-row>

                    </v-card>
                    </v-col>
                </v-row>
        </v-container>
       </v-container>
</template>

<script>
export default {
data: ()=> {
    return {
            workPos: [
            {
                title: 'Full Stack Developer',
                subtitle: 'Shawn DeWolfe Consulting',
                text: 'Developed the frontend of two mobile apps using React.js and Ionic. Aswell, implemented the user-related REST APIs for a fitness app',
                img: 'https://pbs.twimg.com/profile_images/1114724904018927617/OFdeiSCT.jpg',
            },{
                title: 'Learning Technologies Expert',
                subtitle: 'University of British Columbia',
                text: 'Taught and assisted over 70 professors in learning technologies to improve the quality of teaching and learning in class.',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/UBC.png?raw=true',
            },{
                title: 'Frontend Developer',
                subtitle: 'University of British Columbia',
                text: 'Developed two official UBC websites which provided guides and support to all professors on UBC’s learning management system (LMS Canvas)',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/UBC.png?raw=true',   
            },{
                title: 'Peer Technology Assistant',
                subtitle: 'University of British Columbia',
                text: 'Troubleshoot computers and printers for students, professors, and staff. Additionally, coordinated fun student events to improve student campus-life. ',
                img: 'https://github.com/rogov-dvp/Images/blob/master/personal-web/UBC.png?raw=true',
            }]
    }
}
}
</script>

<style>

</style>